export class AuxFunctions {

    /**
     * Gets the R (xx0000) bits from a number
     *
     * @param p_num Color number (ie, 0xffff00)
     *
     * @return The R value
     */
    public static numberToR(p_num: number): number {
        // The initial & is meant to crop numbers bigger than 0xffffff
        return (p_num & 0xff0000) >> 16;
    }

    /**
     * Gets the G (00xx00) bits from a number
     *
     * @param p_num Color number (ie, 0xffff00)
     *
     * @return The G value
     */
    public static numberToG(p_num: number): number {
        return (p_num & 0xff00) >> 8;
    }

    /**
     * Gets the B (0000xx) bits from a number
     *
     * @param p_num Color number (ie, 0xffff00)
     *
     * @return The B value
     */
    public static numberToB(p_num: number): number {
        return (p_num & 0xff);
    }

    /**
     * Returns the number of properties an object has
     *
     * @param p_object Target object with a number of properties
     *
     * @return Number of total properties the object has
     */
    public static getObjectLength(p_object: Object): number {
        let totalProperties: number = 0;
        for (const pName in p_object) totalProperties++;
        return totalProperties;
    }

    /**
     * Takes a variable number of objects as parameters and "adds" their properties, from left to right. If a latter object defines a property as null, it will be removed from the final object
     *
     * @param args A variable number of objects
     *
     * @return	An object with the sum of all parameters added as properties.
    */
    public static concatObjects(...args: Array<any>): Object {
        const finalObject: any = {};
        let currentObject: any;
        for (let i: number = 0; i < args.length; i++) {
            currentObject = args[i];
            for (const prop in currentObject) {
                if (currentObject[prop] == null) {
                    // delete in case is null
                    delete finalObject[prop];
                } else {
                    finalObject[prop] = currentObject[prop];
                }
            }
        }
        return finalObject;
    }
}
